__turbopack_context__.v({
  "ButtonThumb": "_2oJuMq_ButtonThumb",
  "Buttons": "_2oJuMq_Buttons",
  "Container": "_2oJuMq_Container",
  "Footer": "_2oJuMq_Footer",
  "FooterWrapper": "_2oJuMq_FooterWrapper",
  "LastUpdated": "_2oJuMq_LastUpdated",
  "Line": "_2oJuMq_Line",
  "Root": "_2oJuMq_Root",
  "Wrapper": "_2oJuMq_Wrapper",
});
